import React, { useEffect, useState } from "react";
import Seo from "../components/Generic/Seo";
import HeroModule from "../components/Home/HeroModule";
import About1 from "../components/Home/About1";
// import HeroCarousel from "../components/Home/HeroCarousel";
import C2c2c from "../components/Home/C2C2C";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import UpcomingOngoingEvents from "../components/Event/Upcomingevents";
import { getByQuery } from "../api/API";
import LoadingSpinner from "../components/Generic/LoadingSpinner";
import InViewFade from "../components/Generic/InViewFade";
import CohortButton from "../components/Home/CohortButton";

const Home = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const seoData = {
    title: "WiSE — Women in Semiconductor Ecosystem",
    description:
      "WiSE (Women in Semiconductor Ecosystem) is a vibrant community empowering, connecting and elevating women from campus to corporate to career. Join mentorship, collaboration and opportunity programs that build skills, confidence and inclusive leadership in the semiconductor industry.",
    keywords:
      "Women in semiconductor, WiSE, women in tech, semiconductor careers for women, semiconductor mentorship, campus to corporate programs, women leadership semiconductor, women in engineering community, semiconductor networking for women, inclusive semiconductor industry, mentorship for female engineers, semiconductor career development, women in STEM semiconductor, female professionals semiconductor, semiconductor diversity and inclusion",
    pathSlug: "",
  };

  const getEventStatus = (dateFrom, dateTo) => {
    const today = new Date();
    const startDate = new Date(dateFrom);
    const endDate = new Date(dateTo);
    if (today < startDate) return "Upcoming";
    if (today >= startDate && today <= endDate) return "Ongoing";
    return "Completed";
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  const formatTime = (time) =>
    new Date(time).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

  useEffect(() => {
    async function fetchEvents() {
      try {
        const data = await getByQuery(
          "events",
          "where[_status][equals]=published"
        );
        setEvents(data.docs || []);
      } catch (err) {
        console.error("Error fetching events:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchEvents();
  }, []);

  return (
    <>
      <Seo data={seoData} />
      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <HeroModule />

      <InViewFade>
        <About1 />
      </InViewFade>

      <InViewFade direction="right">
        <C2c2c />
      </InViewFade>

      <InViewFade>
        <CohortButton />
      </InViewFade>

      {/*<InViewFade>
        <FeaturedStories />
      </InViewFade>*/}

      <div className="container my-5">
        <h2 className="mb-4">Upcoming events and trainings </h2>

        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <LoadingSpinner />
          </div>
        ) : (
          <InViewFade amount={0.2} direction="left">
            <UpcomingOngoingEvents
              events={events}
              getEventStatus={getEventStatus}
              formatDate={formatDate}
              formatTime={formatTime}
            />
          </InViewFade>
        )}
      </div>
    </>
  );
};

export default Home;
